<script lang="ts">
  import { userStore } from "../auth";

  const className =
    "rounded-md border border-gray-300 shadow-sm px-2 py-1 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500 disabled:opacity-50";
</script>

{#if $userStore?.uid}
  <button
    class={className}
    data-feedback-fish
    data-feedback-fish-userid={$userStore?.uid}>
    Feedback
  </button>
{:else}<button class={className} data-feedback-fish>Feedback</button>{/if}
